import Siema from '../../../js/vendor/siema';
import { Helper } from '../../../js/util/helper';

export default class TeaserSmall {
  constructor( node ) {
    this.node = node;
    this.variant = parseInt( node.getAttribute( 'data-variant' ));
    this.isSwipeable = node.classList.contains( 'teaser-small--swipeable' );
    this.slider = null;
    this.tabletPortraitSize = 768;
    this.handleVariants();
    this.handleLink();
  }
  handleVariants() {
    if ( this.isSwipeable ) {
      this.slider = this.initSlider();
      this.isSlider = true;
      this.addPagination();
      this.watchWindowSize();
      this.setActivePagination( 0 );
    }
  }
  initSlider() {
    return new Siema({
      selector: this.node,
      loop: true,
      onChange: this.setActivePagination.bind( this )
    });
  }
  addPagination() {
    let wrapper = Helper.getClosest( this.node, '.teaser-small-wrapper' );
    let paginationBtns = wrapper.querySelectorAll( '.teaser-small__pagination-box' );
    for ( let paginationBtn of paginationBtns ) {
      paginationBtn.addEventListener( 'click', () => {
        const index = paginationBtn.getAttribute( 'data-index' );
        this.slider.goTo( index );
        this.setActivePagination( index );
      });
    }
  }
  setActivePagination( index = -1 ) {
    let wrapper = Helper.getClosest( this.node, '.teaser-small-wrapper' ),
      paginationBtns = wrapper.querySelectorAll( '.teaser-small__pagination-box' ),
      active = wrapper.querySelector( '.teaser-small__pagination-box--active' );
    const current = ( index === -1 ) ? this.slider.currentSlide : index;
    if ( active !== null ) {
      active.classList.remove( 'teaser-small__pagination-box--active' );
    }
    paginationBtns[ current ].classList.add( 'teaser-small__pagination-box--active' );
  }
  watchWindowSize() {
    if ( window.innerWidth >= this.tabletPortraitSize && this.slider !== -1 ) {
      this.slider.destroy( true );
      this.isSlider = false;
    }
    window.addEventListener( 'resize', () => {
      if ( window.innerWidth < this.tabletPortraitSize && this.isSwipeable && !this.isSlider ) {
        this.slider = this.initSlider();
        this.isSlider = true;
      } else if ( window.innerWidth >= this.tabletPortraitSize && this.isSwipeable && this.isSlider ) {
        this.slider.destroy( true );
        this.isSlider = false;
      }
    });
  }

  /**
   * if container is clicked => trigger link inside
   */
  handleLink() {
    let containers = this.node.querySelectorAll( '.teaser-small__container' );

    for ( let container of containers ) {
      container.addEventListener( 'click', () => {
        container.children[ 1 ].children[ 2 ].click();
      });
    }
  }
}
